import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Typography, FormControl, MenuItem, Chip, Grid, Card, CircularProgress } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Controller, useForm } from 'react-hook-form';
import { jobRoleFacilitySchema } from '../../../hooks/validationSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { useDispatch, useSelector } from 'react-redux';
import { useTMutation } from '../../../utils/useTMutation';
import showToast from '../../../components/Hot-Toast/showToast';
import { useTQuery } from '../../../utils/useTQuery';
import { nextStep, prevStep } from '../../../slice/signupFormSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { use } from 'react';

export default function AddSpecialtyFacility() {
    const dispatch = useDispatch();
    const location = useLocation();
    const { formattedData } = location.state;
    console.log("formattedData", formattedData);
    const { userDetails } = useSelector(state => state.user);
    console.log("userDetails", userDetails);
    // const { step, values } = useSelector((state) => state.signupForm);
    const navigate = useNavigate();
    const [fetchedJobRoles, setFetchedJobRoles] = useState([]);
    const [selectedJobRoles, setSelectedJobRoles] = useState(formattedData?.JOBROLES_LIST || []);
    console.log("selectedJobRoles", selectedJobRoles);
    // const [selectedJobRoles, setSelectedJobRoles] = useState([]);

    // const { data: specialitiesList, isLoading } = useTQuery("specialties", "/specialty", "post");
    const { data: jobRoleList, isLoading } = useTQuery("jobRoles", "/specialties", "get");
    console.log("jobRoleList", jobRoleList);
    useEffect(() => {
        if (jobRoleList?.STATUS) {
            setFetchedJobRoles(jobRoleList.OUTPUT);
        }
    }, [jobRoleList]);

    const { control, handleSubmit, setValue, clearErrors, formState: { errors } } = useForm({
        resolver: zodResolver(jobRoleFacilitySchema),
        defaultValues: { JOBROLES_LIST: formattedData?.JOBROLES_LIST || [] }
        // defaultValues: {}
    });

    useEffect(() => {
        if (formattedData?.JOBROLES_LIST && formattedData.JOBROLES_LIST.length > 0) {
            setSelectedJobRoles(formattedData.JOBROLES_LIST);
        }
    }, [formattedData?.JOBROLES_LIST]);
    
    useEffect(() => {
        setValue('JOBROLES_LIST', selectedJobRoles);
        if (selectedJobRoles.length > 0) {
            clearErrors('JOBROLES_LIST');
        }
    }, [selectedJobRoles, setValue, clearErrors]);

    const handleJobroleChange = (event) => {
        const selectedValue = event.target.value;
        if (selectedValue && !selectedJobRoles.some((s) => s.id === selectedValue)) {
            const selectedJobRole = fetchedJobRoles.find((s) => s.ID === selectedValue);
            if (selectedJobRole) {
                setSelectedJobRoles([...selectedJobRoles, { id: selectedValue, name: selectedJobRole.ROLE_NAME }]);
            }
        }
    };

    const handleDelete = (specialtyToDelete) => () => {
        setSelectedJobRoles((currentSpecialties) =>
            currentSpecialties.filter((specialty) => specialty.id !== specialtyToDelete.id)
        );
    };

    const mutation = useTMutation("/user", "post", (data) => {
        if (data.STATUS) {
            return data;
        }
    });
    console.log("error", errors)
    const onSubmitNext = async (data) => {
        console.log("data", data);
        try {
            const formData = {
                ...data,
                USER_ID: userDetails.ID,
                // last_completed_step: step,
            };

            const response = await mutation.mutateAsync(formData);
            if (response?.STATUS) {
                showToast("success", response.MESSAGE, 3000);
                navigate("/facility/profile");
                // dispatch(nextStep());
            } else {
                showToast("error", response.MESSAGE, 3000);
            }
        } catch (error) {
            console.log(error.message);
            showToast('error', error.message, 3000);
        }
    };
    const handleBack = () => {
        // dispatch(prevStep());
        navigate(-1)
    }
    return (
        <>
<Button
                        sx={{
                            textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 0, minWidth: 0, color: "#000000 !important", opacity: "87% !important"
                        }}
                        onClick={handleBack}
                    >
                        <ArrowBackIosIcon sx={{ fontSize: "20px" }} />Back
                    </Button>
        <Grid item xs={12} lg={12} sx={{ display: "flex", paddingTop: 0, justifyContent: "center", alignItems: "center", height: "80vh" }}>
            <Card sx={{ boxShadow: "none", padding: " 30px", width: "40%", alignItems: "center" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={1} mb={2}>
                    
                </Box>
                <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>
                    Select Job roles
                </Typography>
                <Typography gutterBottom mt={-2} sx={{ fontWeight: 400, fontSize: "16px", color: "#000000", opacity: "60%", width: "21.5rem" }}>
                    Select the job roles your facility focuses on.
                </Typography>

                <form onSubmit={handleSubmit(onSubmitNext)}>
                    <FormControl fullWidth sx={{ marginTop: 3 }}>
                        <Controller
                            name="JOBROLES_LIST"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    select
                                    label="Select Job Roles"
                                    value=""
                                    onChange={(e) => {
                                        handleJobroleChange(e);
                                        // field.onChange([]);
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: 1.814
                                        },
                                    }}
                                    error={!!errors.JOBROLES_LIST}
                                    helperText={errors.JOBROLES_LIST?.message}
                                    // disabled={isLoading}
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: {
                                                style: { maxHeight: 400 },
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem disabled value="">Select</MenuItem>
                                    {fetchedJobRoles.map((jobRole) => (
                                        <MenuItem key={jobRole.ID} value={jobRole.ID}>
                                            {jobRole.ROLE_NAME}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}
                        />
                    </FormControl>

                    <Grid container spacing={1} mt={2} justifyContent="center">
                        {selectedJobRoles.map((specialty) => (
                            <Grid item xs={4} key={specialty.id} display="flex" justifyContent="center">
                                <Chip
                                    label={specialty.name}
                                    onDelete={handleDelete(specialty)}
                                    sx={{
                                        borderRadius: 0.9,
                                        width: '100%',
                                        textAlign: 'center',
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <Box display="flex" justifyContent="end" alignItems="center" style={{ marginTop: 15 }}>
                        {/* <Typography
                        sx={{ color: "#000000", opacity: "60%", fontSize: "14px", cursor: "pointer" }}
                        // onClick={() => dispatch(nextStep())}
                    >
                        Skip
                    </Typography> */}

                        <Button
                            type="submit"
                            variant="contained"
                            className='custombuttons'
                            disabled={mutation.isPending}
                        >
                            {mutation.isPending ? <CircularProgress size={24} /> : "Next"}
                        </Button>
                    </Box>
                </form>
            </Card>
        </Grid>
        </>
    );
}
